import { BackendMockModule } from './mock-service.module';

export {
  BackendMockModule
} from './mock-service.module';

export { // export db
  InMemoryBackendMockService } from './services/in-memory-data.service';
